import React, { useState } from 'react'
import moment from 'moment'
import numeral from 'numeral'
import * as UI from 'konsys-ui'
import _ from 'lodash'
import { Query } from 'react-apollo'
import {
  Col, Upload, Select, Input, Spin, DatePicker, TimePicker,
} from 'antd'
import { GET_SENDERS, GET_RECEIVERS } from '../../../constants/graphql/query'
import { RemarkRenderer } from '../../../components/shipping-order-components'
import { unitText, detailMode, status } from '../constants'
import { AssignDriver, AssignFillingOrder } from './extension-components'
import PERMISSION from '../../../constants/permissions'
import { checkNotNumber } from '../../../utils/util-services'
import { UploadWithModal } from '../../../components/common'

/*
date.type is type of component
0: InputWithLabel
1: input
2: Text (P) 2 lines
3: Dropdown (Select)
4: Upload
5: Datepicker
6: TextArea
7:
8: Text (P) 1 line
9: Button
10: Datepicker
11: Timepicker
*/

const CreateMode = ({
  data, onChangeHandler, client, driverDataHandler, fuelTypeHandler, jobData, mutationVariables,
}) => {
  const [name, setName] = useState('')
  switch (data.type) {
    case 0:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.InputWithLabel
            {...data.props}
            input={{
              onKeyDown: e => checkNotNumber(e) && e.preventDefault(),
              onChange: e => onChangeHandler(data.id, e.target.value),
              type: 'number',
              step: '0.1',
              min: '0',
            }}
          />
        </Col>
      )
    case 1:
      return (
        <Col span={data.span}>
          <UI.Input {...data.props} />
        </Col>
      )
    case 2:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.P {...data.props}>{data.label}</UI.P>
          <UI.P {...data.props}>{client.clientInfo[data.id]}</UI.P>
        </Col>
      )
    case 3:
      return (
        <Col span={data.span}>
          <UI.P {...data.props} margin='0 0 16px' display='block'>{data.label}</UI.P>
          <Select defaultValue="ตัน" style={{ width: '100%' }} onChange={e => onChangeHandler(data.id, e)}>
          {
            data.children.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
          }
          </Select>
        </Col>
      )
    case 4:
      return (
        <Col span={data.span}>
          <UploadWithModal
            onChange={e => onChangeHandler(data.id, e.fileList.map(v => v.originFileObj))}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            button={data.props}
            listType='picture'
          />
        </Col>
      )
    case 6:
      return (
        <Col span={data.span}>
          <UI.P {...data.props} display='block' margin='0 0 16px'>{data.label}</UI.P>
          <Input.TextArea rows={4} style={{ margin: '0 0 16px' }} onChange={e => onChangeHandler(data.id, e.target.value)}/>
        </Col>
      )
    case 7: // customerlist query only
    {
      const isStartDestination = data.id === 'startDestination'
      return <Col
            span={data.span}
          >
            <Query
              query={isStartDestination ? GET_SENDERS : GET_RECEIVERS}
              variables={{
                name,
                limit: 5,
              }}
            >{({ data: respData, loading: respLoading, error: respError }) => {
              if (respLoading && _.isEmpty(respData)) return <UI.Loading center='true' />
              if (respError) return <UI.P>เกิดข้อผิดพลาด</UI.P>
              const list = isStartDestination ? respData.SenderLocationList.lists : respData.ReceiverLocationList.lists
              const mappedData = list.map(v => ({
                id: v.id, name: v.name, branch: v.branch,
              }))
              return (
                <UI.Div display='flex' flexDirection='column' margin='0'>
                  <UI.P margin='0 0 16px'>{data.label}</UI.P>
                  <Select
                    loading={respLoading}
                    defaultValue={isStartDestination
                      ? !_.isNull(jobData.startDestinationLocation) && jobData.startDestinationLocation.name
                      : !_.isNull(jobData.endDestinationLocation) && jobData.endDestinationLocation.name}
                    showSearch
                    optionFilterProp="children"
                    notFoundContent={respLoading ? <Spin size="small" /> : null}
                    onSearch={e => setName(e)}
                    onChange={(e) => {
                      const clientObj = _.find(mappedData, o => o.id === e)
                      onChangeHandler(data.id, clientObj.id)
                      client.setClientHandler({ [`${data.id}Text`]: clientObj.branch })
                    }}
                    onBlur={() => {
                      if (data.id === 'startDestination') {
                        if (_.isUndefined(client.clientInfo.startDestination)) setName('')
                      } else if (data.id === 'endDestination') {
                        if (_.isUndefined(client.clientInfo.endDestination)) setName('')
                      }
                    }}
                    style={{ width: '100%' }}
                  >
                  {
                    mappedData.map((v, i) => <Select.Option key={i} value={v.id}>{v.name}</Select.Option>)
                  }
                  </Select>
                </UI.Div>
              )
            }}
            </Query>
          </Col>
    }
    case 8:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.P {...data.props}>{_.isUndefined(data.label)
            ? client.clientInfo[data.id]
            : data.label}
          </UI.P>
        </Col>
      )
    case 9:
      return (
        [
          <Col span={6} key='offset' />,
          <Col span={data.span} key='input'>
            <UI.P {...data.props} margin='0 0 16px' display='block'>{data.label}</UI.P>
            <Select style={{ width: '100%' }} defaultValue={data.defaultValue} onChange={e => onChangeHandler(data.id, e)}>
            {
              data.children.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
            }
            </Select>
          </Col>,
        ]
      )
    case 13:
      return (
        <Col span={data.span} offset={data.offset} className='my-4'>
          <UI.P {...data.props}>{`${data.label}: ${(_.isUndefined(mutationVariables[data.id]) || _.isNil(mutationVariables.availableOrder)) ? '-' : mutationVariables[data.id]}`}</UI.P>
        </Col>
      )
    default:
      return <p>No type</p>
  }
}

const unitSelection = (e) => {
  switch (e) {
    case 'TON': return unitText.TON
    case 'KG': return unitText.KG
    case 'H50': return unitText.H50
    // case 'H60': return unitText.H60
    // case 'H100': return unitText.H100
    default: return 'ไม่ระบุ'
  }
}

const EditMode = ({
  data, onChangeHandler, client, disabled, initialData, driverDataHandler, fuelTypeHandler, mutationVariables, isEdit, onlyStartEndDestination,
}) => {
  const [name, setName] = useState('')
  const isExpiredEditMode = isEdit && initialData?.status === status.EXPIRED
  switch (data.type) {
    case 0:
    {
      const value = data.id === 'unit' ? unitSelection(initialData[data.id]) : initialData[data.id]
      return (
          <Col span={data.span} offset={data.offset}>
            <UI.InputWithLabel
              {...data.props}
              input={{
                disabled: disabled || data.id === 'unit' || initialData.status === status.CANCELLED || onlyStartEndDestination || (isExpiredEditMode && _.includes(['compensation', 'weightDifferenceLimit'], data.id)),
                onKeyDown: e => checkNotNumber(e) && e.preventDefault(),
                onChange: e => onChangeHandler(data.id, e.target.value),
                defaultValue: !disabled ? value : numeral(value).format('0,0.00'),
                type: !disabled ? 'number' : 'text',
                step: !disabled ? '0.1' : undefined,
                min: '0',
              }}
            />
          </Col>
      )
    }
    case 1:
      return (
        <Col span={data.span}>
          <UI.Input {...data.props} disabled={disabled || onlyStartEndDestination} defaultValue={initialData[data.id]} />
        </Col>
      )
    case 2:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.P {...data.props}>{data.label}</UI.P>
          <UI.P {...data.props}>{_.isEmpty(client.clientInfo) ? initialData.Customer[data.id] : client.clientInfo[data.id]}</UI.P>
        </Col>
      )
    case 3:
      return (
        <Col span={data.span}>
          <UI.P {...data.props} margin='0 0 16px' display='block'>{data.label}</UI.P>
          <Select
            disabled={disabled || onlyStartEndDestination}
            defaultValue={!_.isUndefined(_.find(data.children, o => o.value === initialData[data.id])) && _.find(data.children, o => o.value === initialData[data.id]).text}
            style={{ width: '100%' }}
            onChange={e => onChangeHandler(data.id, e)}
          >
          {
            data.children.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
          }
          </Select>
        </Col>
      )
    case 4:
      return (
        <Col span={data.span}>
          <UploadWithModal
            onChange={e => onChangeHandler(data.id, e.fileList.map(v => (_.isUndefined(v.originFileObj) ? { url: v.url } : v.originFileObj)))}
            showUploadList={{
              showRemoveIcon: !disabled || !onlyStartEndDestination,
            }}
            disabled={disabled || initialData.status === status.CANCELLED || onlyStartEndDestination}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            defaultFileList={initialData[data.id]?.map(v => ({
              name: v.filename,
              url: v.url,
              uid: v.url,
            }))}
            button={data.props}
            listType='picture'
          />
        </Col>
      )
    case 6:
      if (disabled || onlyStartEndDestination) {
        return (
          <Col span={data.span}>
            <UI.P {...data.props} display='block' margin='0 0 16px'>{data.label}</UI.P>
            <RemarkRenderer data={initialData[data.id]} />
          </Col>
        )
      }
      return (
        <Col span={data.span}>
          <UI.P {...data.props} display='block' margin='0 0 16px'>{data.label}</UI.P>
          <Input.TextArea defaultValue={initialData[data.id]} disabled={disabled || onlyStartEndDestination} rows={4} style={{ margin: '0 0 16px' }} onChange={e => onChangeHandler(data.id, e.target.value)}/>
        </Col>
      )
    case 7: // customerlist query only
    {
      const isStartDestination = data.id === 'startDestination'
      return <Col
            span={data.span}
          >
            <Query
              query={isStartDestination ? GET_SENDERS : GET_RECEIVERS}
              variables={{
                name,
                limit: 5,
              }}
            >{({ data: respData, loading: respLoading, error: respError }) => {
              if (respLoading && _.isEmpty(respData)) return <UI.Loading center='true' />
              if (respError) return <UI.P>เกิดข้อผิดพลาด</UI.P>
              const list = isStartDestination ? respData.SenderLocationList.lists : respData.ReceiverLocationList.lists
              const mappedData = list.map(v => ({
                id: v.id, name: v.name, branch: v.branch,
              }))
              return (
                <UI.Div display='flex' flexDirection='column' margin='0'>
                  <UI.P margin='0 0 16px'>{data.label}</UI.P>
                  <Select
                    defaultValue={initialData[data.id]}
                    disabled={disabled || initialData.status === status.CANCELLED || (isExpiredEditMode && _.includes(['startDestination', 'endDestination'], data.id))}
                    showSearch
                    optionFilterProp="children"
                    notFoundContent={respLoading ? <Spin size="small" /> : null}
                    onSearch={e => setName(e)}
                    onChange={(e) => {
                      const clientObj = _.find(mappedData, o => o.id === e)
                      onChangeHandler(data.id, clientObj.id)
                      client.setClientHandler({ [`${data.id}Text`]: clientObj.branch })
                    }}
                    onBlur={() => {
                      if (data.id === 'startDestination') {
                        if (_.isUndefined(client.clientInfo.startDestination)) setName('')
                      } else if (data.id === 'endDestination') {
                        if (_.isUndefined(client.clientInfo.endDestination)) setName('')
                      }
                    }}
                    style={{ width: '100%' }}
                  >
                  {
                    mappedData.map((v, i) => <Select.Option key={i} value={v.id}>{v.name}</Select.Option>)
                  }
                  </Select>
                </UI.Div>
              )
            }}
            </Query>
          </Col>
    }
    case 8:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.P {...data.props}>{_.isUndefined(data.label) ? client.clientInfo[data.id] : data.label}</UI.P>
        </Col>
      )
    case 9:
      return (
        <Col span={data.span}>
          <UI.P {...data.props} margin='16px 0' display='block'>{data.label}</UI.P>
          <Select style={{ width: '100%' }} disabled={disabled || onlyStartEndDestination || (isExpiredEditMode && data.id === 'containerOption')} defaultValue={initialData[data.id]} onChange={e => onChangeHandler(data.id, e)}>
          {
            data.children.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
          }
          </Select>
        </Col>
      )
    case 10:
      return (
        <Col
          span={data.span}
          style={{ margin: data.props.margin }}
        >
          <UI.Div display='flex' flexDirection='column' margin='0'>
            <UI.P margin='0 0 16px'>{data.label}</UI.P>
            <DatePicker disabled={onlyStartEndDestination} onChange={e => onChangeHandler(data.id, moment(e).format('YYYY-MM-DD'))} />
          </UI.Div>
        </Col>
      )
    case 11:
      return (
        <Col
          span={data.span}
          style={{ margin: data.props.margin }}
        >
          <UI.Div display='flex' flexDirection='column' margin='0'>
            <UI.P margin='0 0 16px'>{data.label}</UI.P>
            <TimePicker style={{ width: '100%' }} disabled={onlyStartEndDestination} format='HH:mm' onChange={e => onChangeHandler(data.id, moment(e).format('HH:mm'))} />
          </UI.Div>
        </Col>
      )
    case 13:
      return null
    default:
      return <p>No type</p>
  }
}

export default ({
  data, mode, onChangeHandler, client, initialData, driverDataHandler, fuelTypeHandler, accessFuel, accessDelivered, accessDriver, jobData, mutationVariables, onlyStartEndDestination,
}) => {
  switch (mode) {
    case detailMode.ADD:
      return <CreateMode data={data} onChangeHandler={onChangeHandler} client={client} driverDataHandler={driverDataHandler} fuelTypeHandler={fuelTypeHandler} jobData={jobData} mutationVariables={mutationVariables}/>
    case detailMode.EDIT:
      return <EditMode onlyStartEndDestination={onlyStartEndDestination} isEdit={true} data={data} disabled={accessDelivered || accessFuel || accessDriver || !_.includes(window.perms, PERMISSION.UPDATE_SHIPPING_ORDER)} onChangeHandler={onChangeHandler} client={client} initialData={initialData} driverDataHandler={driverDataHandler} fuelTypeHandler={fuelTypeHandler} mutationVariables={mutationVariables}/>
    case detailMode.VIEW:
      return <EditMode data={data} disabled={true} onChangeHandler={onChangeHandler} client={client} initialData={initialData} driverDataHandler={driverDataHandler} fuelTypeHandler={fuelTypeHandler} mutationVariables={mutationVariables}/>
    default:
      return <p>no mode</p>
  }
}
